import { __decorate, __param } from 'tslib';
import { InjectionToken, Optional, Self, Inject, ChangeDetectorRef, ViewChild, Input, HostBinding, Component, ChangeDetectionStrategy, forwardRef, NgModule } from '@angular/core';
import { NgControl } from '@angular/forms';
import { AbstractTuiNullableControl, TUI_DEFAULT_IDENTITY_MATCHER, isNativeFocused, tuiDefaultProp, TUI_FOCUSABLE_ITEM_ACCESSOR, TuiCheckedModule, TuiFocusableModule, TuiFocusedModule, TuiHoveredModule, TuiPressedModule, TuiFocusVisibleModule } from '@taiga-ui/cdk';
import { TUI_ANIMATION_OPTIONS, tuiScaleIn, TuiWrapperModule } from '@taiga-ui/core';
import { TuiRadioGroupComponent } from '@taiga-ui/kit/components/radio-group';
import { CommonModule } from '@angular/common';

/** Default values for the checkbox options. */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@taiga-ui/core';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@taiga-ui/cdk';
import * as ɵngcc4 from '@angular/forms';
import * as ɵngcc5 from '@taiga-ui/kit/components/radio-group';

const _c0 = ["focusableElement"];
function TuiRadioComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 4);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("@tuiScaleIn", ctx_r0.animation);
} }
const TUI_RADIO_DEFAULT_OPTIONS = {
    size: 'm',
    appearances: {
        unchecked: "outline" /* Outline */,
        checked: "primary" /* Primary */,
    },
};
const TUI_RADIO_OPTIONS = new InjectionToken('Default parameters for radio component', {
    factory: () => TUI_RADIO_DEFAULT_OPTIONS,
});
const tuiRadioOptionsProvider = (options) => ({
    provide: TUI_RADIO_OPTIONS,
    useValue: Object.assign(Object.assign({}, TUI_RADIO_DEFAULT_OPTIONS), options),
});

var TuiRadioComponent_1;
// @dynamic
let TuiRadioComponent = TuiRadioComponent_1 = class TuiRadioComponent extends AbstractTuiNullableControl {
    constructor(control, changeDetectorRef, animationOptions, options, radioGroup) {
        super(control, changeDetectorRef);
        this.animationOptions = animationOptions;
        this.options = options;
        this.radioGroup = radioGroup;
        this.identityMatcher = TUI_DEFAULT_IDENTITY_MATCHER;
        this.name = null;
        this.size = this.options.size;
        this.pseudoDisabled = false;
        this.animation = Object.assign({ value: '' }, this.animationOptions);
    }
    get appearance() {
        return this.checked
            ? this.options.appearances.checked
            : this.options.appearances.unchecked;
    }
    get computedDisabled() {
        return this.disabled || this.pseudoDisabled;
    }
    get nativeFocusableElement() {
        return !this.focusableElement || this.computedDisabled
            ? null
            : this.focusableElement.nativeElement;
    }
    get focused() {
        return isNativeFocused(this.nativeFocusableElement);
    }
    get checked() {
        return this.value === null
            ? this.item === null
            : this.item !== undefined && this.identityMatcher(this.value, this.item);
    }
    get computedName() {
        return this.name || this.radioGroupName || this.controlName || null;
    }
    get isFocusable() {
        return !this.readOnly && this.computedFocusable;
    }
    onChecked(checked) {
        if (checked) {
            this.updateValue(this.item !== undefined ? this.item : this.fallbackValue);
        }
    }
    onFocused(focused) {
        this.updateFocused(focused);
    }
    onHovered(hovered) {
        this.updateHovered(hovered);
    }
    onPressed(pressed) {
        this.updatePressed(pressed);
    }
    onFocusVisible(focusVisible) {
        this.updateFocusVisible(focusVisible);
    }
    get radioGroupName() {
        return this.radioGroup === null ? null : this.radioGroup.name;
    }
};
TuiRadioComponent.ɵfac = function TuiRadioComponent_Factory(t) { return new (t || TuiRadioComponent)(ɵngcc0.ɵɵdirectiveInject(NgControl, 10), ɵngcc0.ɵɵdirectiveInject(ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(TUI_ANIMATION_OPTIONS), ɵngcc0.ɵɵdirectiveInject(TUI_RADIO_OPTIONS), ɵngcc0.ɵɵdirectiveInject(TuiRadioGroupComponent, 8)); };
TuiRadioComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TuiRadioComponent, selectors: [["tui-radio"]], viewQuery: function TuiRadioComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, true);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.focusableElement = _t.first);
    } }, hostVars: 3, hostBindings: function TuiRadioComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("data-size", ctx.size);
        ɵngcc0.ɵɵclassProp("_disabled", ctx.computedDisabled);
    } }, inputs: { identityMatcher: "identityMatcher", name: "name", size: "size", pseudoDisabled: "pseudoDisabled", item: "item" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: TUI_FOCUSABLE_ITEM_ACCESSOR,
                useExisting: forwardRef(() => TuiRadioComponent_1)
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 4, vars: 12, consts: [[3, "appearance", "disabled", "focused", "hovered", "pressed", "invalid"], ["class", "mark", 4, "ngIf"], ["type", "radio", 1, "native", 3, "id", "disabled", "tuiChecked", "tuiFocusable", "tuiFocusedChange", "tuiHoveredChange", "tuiPressedChange", "tuiCheckedChange", "tuiFocusVisibleChange"], ["focusableElement", ""], [1, "mark"]], template: function TuiRadioComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "tui-wrapper", 0);
        ɵngcc0.ɵɵtemplate(1, TuiRadioComponent_div_1_Template, 1, 1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "input", 2, 3);
        ɵngcc0.ɵɵlistener("tuiFocusedChange", function TuiRadioComponent_Template_input_tuiFocusedChange_2_listener($event) { return ctx.onFocused($event); })("tuiHoveredChange", function TuiRadioComponent_Template_input_tuiHoveredChange_2_listener($event) { return ctx.onHovered($event); })("tuiPressedChange", function TuiRadioComponent_Template_input_tuiPressedChange_2_listener($event) { return ctx.onPressed($event); })("tuiCheckedChange", function TuiRadioComponent_Template_input_tuiCheckedChange_2_listener($event) { return ctx.onChecked($event); })("tuiFocusVisibleChange", function TuiRadioComponent_Template_input_tuiFocusVisibleChange_2_listener($event) { return ctx.onFocusVisible($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("appearance", ctx.appearance)("disabled", ctx.computedDisabled)("focused", ctx.computedFocusVisible)("hovered", ctx.computedHovered)("pressed", ctx.computedPressed)("invalid", ctx.computedInvalid);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.checked);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("id", ctx.id)("disabled", ctx.computedDisabled)("tuiChecked", ctx.checked)("tuiFocusable", ctx.isFocusable);
        ɵngcc0.ɵɵattribute("name", ctx.computedName);
    } }, directives: [ɵngcc1.TuiWrapperDirective, ɵngcc2.NgIf, ɵngcc3.TuiCheckedDirective, ɵngcc3.TuiFocusableDirective, ɵngcc3.TuiFocusedDirective, ɵngcc3.TuiHoveredDirective, ɵngcc3.TuiPressedDirective, ɵngcc3.TuiFocusVisibleDirective], styles: ["[_nghost-%COMP%]{font:var(--tui-font-text-s);color:var(--tui-text-01);position:relative;display:block;flex-shrink:0;border-radius:100%}[data-size='m'][_nghost-%COMP%]{width:1rem;height:1rem}[data-size='l'][_nghost-%COMP%]{width:1.5rem;height:1.5rem}._readonly[_nghost-%COMP%]{pointer-events:none}.mark[_ngcontent-%COMP%]{position:absolute;background-color:currentColor;border-radius:100%}[data-size='m'][_nghost-%COMP%]   .mark[_ngcontent-%COMP%]{margin:.25rem;width:.5rem;height:.5rem}[data-size='l'][_nghost-%COMP%]   .mark[_ngcontent-%COMP%]{margin:.4375rem;width:.625rem;height:.625rem}.native[_ngcontent-%COMP%]{padding:0;border:0;border-radius:inherit;background:0 0;font-size:inherit;line-height:inherit;font-weight:inherit;color:inherit;caret-color:currentColor;outline:0;-webkit-appearance:none;-moz-appearance:none;appearance:none;word-break:keep-all;-webkit-text-fill-color:currentColor;position:absolute;top:0;left:0;width:100%;height:100%;opacity:0;cursor:pointer}.native[_ngcontent-%COMP%]:-webkit-autofill, .native[_ngcontent-%COMP%]:-webkit-autofill:focus, .native[_ngcontent-%COMP%]:-webkit-autofill:hover{border-radius:inherit;color:inherit!important;background-color:transparent!important;-webkit-text-fill-color:var(--tui-text-01)!important;border-color:var(--tui-autofill);-webkit-box-shadow:0 0 0 1000px var(--tui-autofill) inset!important}._disabled[_nghost-%COMP%]   .native[_ngcontent-%COMP%]{cursor:default}"], data: { animation: [tuiScaleIn] }, changeDetection: 0 });
TuiRadioComponent.ctorParameters = () => [
    { type: NgControl, decorators: [{ type: Optional }, { type: Self }, { type: Inject, args: [NgControl,] }] },
    { type: ChangeDetectorRef, decorators: [{ type: Inject, args: [ChangeDetectorRef,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [TUI_ANIMATION_OPTIONS,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [TUI_RADIO_OPTIONS,] }] },
    { type: TuiRadioGroupComponent, decorators: [{ type: Optional }, { type: Inject, args: [TuiRadioGroupComponent,] }] }
];
__decorate([
    ViewChild('focusableElement')
], TuiRadioComponent.prototype, "focusableElement", void 0);
__decorate([
    Input()
], TuiRadioComponent.prototype, "item", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiRadioComponent.prototype, "identityMatcher", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiRadioComponent.prototype, "name", void 0);
__decorate([
    Input(),
    HostBinding('attr.data-size'),
    tuiDefaultProp()
], TuiRadioComponent.prototype, "size", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiRadioComponent.prototype, "pseudoDisabled", void 0);
__decorate([
    HostBinding('class._disabled')
], TuiRadioComponent.prototype, "computedDisabled", null);
TuiRadioComponent = TuiRadioComponent_1 = __decorate([ __param(0, Optional()),
    __param(0, Self()),
    __param(0, Inject(NgControl)),
    __param(1, Inject(ChangeDetectorRef)),
    __param(2, Inject(TUI_ANIMATION_OPTIONS)),
    __param(3, Inject(TUI_RADIO_OPTIONS)),
    __param(4, Optional()),
    __param(4, Inject(TuiRadioGroupComponent))
], TuiRadioComponent);

let TuiRadioModule = class TuiRadioModule {
};
TuiRadioModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TuiRadioModule });
TuiRadioModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function TuiRadioModule_Factory(t) { return new (t || TuiRadioModule)(); }, imports: [[
            CommonModule,
            TuiCheckedModule,
            TuiFocusableModule,
            TuiFocusedModule,
            TuiHoveredModule,
            TuiPressedModule,
            TuiFocusVisibleModule,
            TuiWrapperModule,
        ]] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiRadioComponent, [{
        type: Component,
        args: [{
                selector: 'tui-radio',
                template: "<tui-wrapper\n    [appearance]=\"appearance\"\n    [disabled]=\"computedDisabled\"\n    [focused]=\"computedFocusVisible\"\n    [hovered]=\"computedHovered\"\n    [pressed]=\"computedPressed\"\n    [invalid]=\"computedInvalid\"\n>\n    <div *ngIf=\"checked\" class=\"mark\" [@tuiScaleIn]=\"animation\"></div>\n    <input\n        #focusableElement\n        type=\"radio\"\n        class=\"native\"\n        [id]=\"id\"\n        [attr.name]=\"computedName\"\n        [disabled]=\"computedDisabled\"\n        [tuiChecked]=\"checked\"\n        [tuiFocusable]=\"isFocusable\"\n        (tuiFocusedChange)=\"onFocused($event)\"\n        (tuiHoveredChange)=\"onHovered($event)\"\n        (tuiPressedChange)=\"onPressed($event)\"\n        (tuiCheckedChange)=\"onChecked($event)\"\n        (tuiFocusVisibleChange)=\"onFocusVisible($event)\"\n    />\n</tui-wrapper>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [
                    {
                        provide: TUI_FOCUSABLE_ITEM_ACCESSOR,
                        useExisting: forwardRef(() => TuiRadioComponent_1)
                    },
                ],
                animations: [tuiScaleIn],
                styles: [":host{font:var(--tui-font-text-s);color:var(--tui-text-01);position:relative;display:block;flex-shrink:0;border-radius:100%}:host[data-size='m']{width:1rem;height:1rem}:host[data-size='l']{width:1.5rem;height:1.5rem}:host._readonly{pointer-events:none}.mark{position:absolute;background-color:currentColor;border-radius:100%}:host[data-size='m'] .mark{margin:.25rem;width:.5rem;height:.5rem}:host[data-size='l'] .mark{margin:.4375rem;width:.625rem;height:.625rem}.native{padding:0;border:0;border-radius:inherit;background:0 0;font-size:inherit;line-height:inherit;font-weight:inherit;color:inherit;caret-color:currentColor;outline:0;-webkit-appearance:none;-moz-appearance:none;appearance:none;word-break:keep-all;-webkit-text-fill-color:currentColor;position:absolute;top:0;left:0;width:100%;height:100%;opacity:0;cursor:pointer}.native:-webkit-autofill,.native:-webkit-autofill:focus,.native:-webkit-autofill:hover{border-radius:inherit;color:inherit!important;background-color:transparent!important;-webkit-text-fill-color:var(--tui-text-01)!important;border-color:var(--tui-autofill);-webkit-box-shadow:0 0 0 1000px var(--tui-autofill) inset!important}:host._disabled .native{cursor:default}"]
            }]
    }], function () { return [{ type: ɵngcc4.NgControl, decorators: [{
                type: Optional
            }, {
                type: Self
            }, {
                type: Inject,
                args: [NgControl]
            }] }, { type: ɵngcc0.ChangeDetectorRef, decorators: [{
                type: Inject,
                args: [ChangeDetectorRef]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [TUI_ANIMATION_OPTIONS]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [TUI_RADIO_OPTIONS]
            }] }, { type: ɵngcc5.TuiRadioGroupComponent, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [TuiRadioGroupComponent]
            }] }]; }, { identityMatcher: [{
            type: Input
        }], name: [{
            type: Input
        }], size: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.data-size']
        }], pseudoDisabled: [{
            type: Input
        }], computedDisabled: [{
            type: HostBinding,
            args: ['class._disabled']
        }], focusableElement: [{
            type: ViewChild,
            args: ['focusableElement']
        }], item: [{
            type: Input
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiRadioModule, { declarations: function () { return [TuiRadioComponent]; }, imports: function () { return [CommonModule,
        TuiCheckedModule,
        TuiFocusableModule,
        TuiFocusedModule,
        TuiHoveredModule,
        TuiPressedModule,
        TuiFocusVisibleModule,
        TuiWrapperModule]; }, exports: function () { return [TuiRadioComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiRadioModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    TuiCheckedModule,
                    TuiFocusableModule,
                    TuiFocusedModule,
                    TuiHoveredModule,
                    TuiPressedModule,
                    TuiFocusVisibleModule,
                    TuiWrapperModule,
                ],
                declarations: [TuiRadioComponent],
                exports: [TuiRadioComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_RADIO_DEFAULT_OPTIONS, TUI_RADIO_OPTIONS, TuiRadioComponent, TuiRadioModule, tuiRadioOptionsProvider };

//# sourceMappingURL=taiga-ui-kit-components-radio.js.map